import React from 'react'
import Link from 'next/link'
import classnames from 'classnames/bind'

import Image from 'components/shared/Image'

import css from './styles.module.scss'

classnames.bind(css)

export default function AuthorContent({ link }) {
  const icon = link?.icons?.[0]

  return (
    <>
      {link && (
        <li className={css.socialLink}>
          <Link
            href={link?.href}
            target={link?.target}
            passHref
            className={css.anchor}
          >
            {icon ? (
              <Image
                format="thumbnail"
                className={css.socialIcon}
                fluid
                {...icon}
                alt=""
              />
            ) : (
              <div />
            )}
          </Link>
        </li>
      )}
    </>
  )
}
